/** @format */
import { css } from 'styled-components';

const baseStyles = () => css`
    width: 100%;
    gap: var(--layout-spacing-16);
    display: flex;
    flex-direction: column;

    .product-details__list {
        margin: 0;
        padding: 0;
        width: 100%;
        z-index: 1;
        gap: var(--layout-spacing-16);
        display: flex;
        flex-direction: column;
    }

    .product-details__sku-container {
        display: flex;
        justify-content: space-between;
        width: 100%;
        z-index: 1;
    }

    .product-details__condition {
        width: 100%;
    }

    .product-details__observations {
        width: 100%;
    }
`;

export const styles = () => {
    return css`
        ${baseStyles()}
    `;
};
